import Reveal from "@/components/site/Reveal";

export default function PageHeader({ overline, title, accent, description, testId = "page-header" }) {
  return (
    <section data-testid={testId} className="pt-40 lg:pt-48 pb-20 lg:pb-28 bg-ivory grain">
      <div className="container-editorial">
        <Reveal as="div" className="max-w-3xl">
          {overline && <p className="overline mb-6">{overline}</p>}
          <h1 className="font-serif text-4xl md:text-5xl lg:text-[4rem] text-navy leading-[1.08]">
            {title}{" "}
            {accent && (
              <em className="font-serif italic text-sage">{accent}</em>
            )}
          </h1>
          {description && (
            <p className="font-sans text-base md:text-lg text-charcoal/65 mt-8 leading-[1.8] max-w-2xl">
              {description}
            </p>
          )}
          <span className="gold-rule mt-12 block" />
        </Reveal>
      </div>
    </section>
  );
}
